import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { InfoProgramSection } from "../Section";
import { Formik } from "formik";
import {
  formInitialValues,
  formSubmmitMapper,
  formValidationSchema,
} from "../Utils";
import { ActionButton, DataStatus } from "components";
import { ProgramApi } from "api";

export const ModalDetailProgram = ({
  setModalConfig,
  modalConfig,
  dropdown,
  formSubmitHandler,
}) => {
  const [dataDetail, setDataDetail] = useState({});
  const [isModalLoading, setIsModalLoading] = useState(true);

  const getDataSingle = () => {
    ProgramApi.getSingle({ id_program: modalConfig.id })
      .then(({ data }) => {
        setDataDetail(data?.data);
      })
      .catch(() => {})
      .finally(() => {
        setIsModalLoading(false);
      });
  };

  useEffect(() => {
    getDataSingle();

    return () => {
      setIsModalLoading(false);
    };
  }, []);

  return (
    <div>
      <Modal
        show={modalConfig?.show}
        onHide={() => setModalConfig({ data: {}, type: "add", show: false })}
        size="lg"
      >
        <Formik
          enableReinitialize
          initialValues={formInitialValues(dataDetail)}
          // validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({ isSubmitting, handleSubmit, resetForm }) => (
            <form onSubmit={handleSubmit}>
              <Modal.Header closeButton>Detail Program</Modal.Header>
              <Modal.Body>
                {isModalLoading ? (
                  <DataStatus loading text="Memuat Data" />
                ) : (
                  <>
                    <InfoProgramSection />
                  </>
                )}
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};
